<template>
    <div class="content">
        <div class="LogReg">
            <statusBar></statusBar>
            <div class="header">
                <div class="close">
                    <i class="iconfont icon-s-cuowu-guanbi" @click="onRequestClose"></i>
                </div>
                <!-- <div class="logo">
                    <img :src="logoUrl" />
                </div> -->
                <!-- <div class="desc1">{{$t("bonusCenter.Signbonus")}}</div> -->
                <div class="moneyVal">{{ eventRegisterReward }}</div>
            </div>
            <div class="LogReg-content">
                <div class="tabs">
                    <div class="tab-item" :class="{ 'act': act == 1 }" @click="onChangeTab(1)">
                        <img src="@/assets/common/liwu.png" alt="" class="empty_img">
                        {{ $t("login.SignUp")
                    }}</div>
                    <div class="tab-item" :class="{ 'act': act == 2 }" @click="onChangeTab(2)">
                        {{ $t("login.SignIn") }}
                    </div>
                    <div
                        class="tab-line"
                        :class="{ 'tab-line-right': act == 2 }"
                    ></div>
                </div>
                <div class="form-box">
                    <transition :name="authTransitionName" mode="out-in">
                    <div class="form" v-if="act == 1" key="signup">
                        <a-form-model ref="ruleForm1" :model="form1" :rules="rules1" @submit.native.prevent>
                            <a-form-model-item ref="phone" label="" prop="phone">
                                <a-input v-model="form1.phone" type="number" :placeholder="$t('login.phone')" class="phone">
                                    <language slot="prefix" :show="true" :showIcon="true"></language>
                                    <span slot="prefix">{{ phoneCode }}</span>
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item ref="password" label="" prop="password">
                                <a-input-password v-model="form1.password" :placeholder="$t('login.password')"
                                    autocomplete="new-password" allowClear>
                                    <i slot="prefix" class="iconfont icon-mima" />
                                </a-input-password>
                            </a-form-model-item>
                            <a-form-model-item ref="password" label="" prop="matchPassword">
                                <a-input-password v-model="form1.matchPassword" :placeholder="$t('login.ConfirmPwdAgain')"
                                    autocomplete="new-password" allowClear>
                                    <i slot="prefix" class="iconfont icon-mima" />
                                </a-input-password>
                            </a-form-model-item>
                            <a-form-model-item ref="inviteUrl" label="" prop="inviteUrl">
                                <a-input v-model="form1.inviteMemberId" :disabled="!!$store.getters.invitCode"
                                    :placeholder="$t('login.InvitationCode')">
                                    <i slot="prefix" class="iconfont icon-shebeizhuce" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model>
                        <div class="bonus-btn-wrap">
                            <div class="bonus-badge">
                                <img class="bonus-badge__icon" src="@/assets/common/bonus_gift_badge.png" alt="">
                                <span>+{{ eventRegisterReward }}</span>
                            </div>
                            <a-button class="btn btn-bonus" @click="handleSubmit('ruleForm1')">Regístrate Para Obtener Un Bono</a-button>
                        </div>
                        <div class="remember">
                            <div class="check-box" @click="argeeService = !argeeService">
                                <i v-if="argeeService" class="iconfont icon-xuanzeyixuanze checked"></i>
                                <i v-else class="iconfont icon-a-xuanzeweixuanze"></i>
                            </div>
                            <div class="tips">
                                {{ $t('login.OverAgeAgree') }}
                                <span class="txt">《{{ $t("login.TermsOfService") }}》</span>
                            </div>
                        </div>
                    </div>
                    <div class="form" v-else key="signin">
                        <a-form-model ref="ruleForm2" :model="form2" :rules="rules2" @submit.native.prevent>
                            <a-form-model-item ref="phone" label="" prop="phone">
                                <a-input v-model="form2.phone" :placeholder="$t('login.accountOrPhone')" class="account">
                                    <language slot="prefix" :show="true" :showIcon="true"></language>
                                    <!-- <span slot="prefix">{{ phoneCode }}</span> -->
                                </a-input>
                            </a-form-model-item>
                            <a-form-model-item ref="password" label="" prop="password">
                                <a-input-password v-model="form2.password" :placeholder="$t('login.password')"
                                    autocomplete="new-password" allowClear>
                                    <i slot="prefix" class="iconfont icon-mima" />
                                </a-input-password>
                            </a-form-model-item>
                        </a-form-model>
                        <div class="remember">
                            <div class="check-box" @click="rememberMe = !rememberMe">
                                <i v-if="rememberMe" class="iconfont icon-xuanzeyixuanze checked"></i>
                                <i v-else class="iconfont icon-a-xuanzeweixuanze"></i>
                            </div>
                            <div class="tips">
                                {{ $t("login.RememberYouraccountPassword") }}
                            </div>
                        </div>
                        <a-button class="btn" @click="handleSubmit('ruleForm2')">{{ $t("login.SignIn") }}</a-button>
                    </div>
                    <!-- 注册倒计时 -->
                    </transition>
                    <div v-if="act == 1 && !isCanRegister" class="time_down_box">
                        <div class="time_down">
                            <div class="time_down_title">{{ $t("login.downTime") }}</div>
                            <div class="time_down_time">
                                <span>{{ $t("login.also") }}：</span>
                                <van-count-down :time="timestamp" :format="'DD ' + $t('login.day') + ' HH:mm:ss'">
                                </van-count-down>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showExitConfirm" class="exit-confirm-mask" @click.self="showExitConfirm = false">
                <div class="exit-confirm">
                    <div class="exit-confirm__title">Obtenga un bono de registro</div>
                    <div class="exit-confirm__amount">{{ eventRegisterReward }}</div>
                    <div class="exit-confirm__desc">¿Está seguro de que quieres renunciar a la recompensa que está a tu alcance?</div>
                    <div class="exit-confirm__actions">
                        <div class="exit-confirm__btn exit-confirm__btn--primary" @click="showExitConfirm = false">Continuar Con El Registro</div>
                        <div class="exit-confirm__btn exit-confirm__btn--ghost" @click="forceClose">Rechazo Cruel</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { login, getUserInfo, userRegisterByBash64 } from '@/api/user'
import { getNationInfo } from '@/api/system'
import md5 from 'md5'
import language from '@/components/language'
import statusBar from '@/components/statusBar'
import { domainName } from '@/common/http'
export default {
    name: 'accountForm',
    components: { language, statusBar },
    data() {
        const validatePass1 = (rule, value, callback) => {
            const reg = /^[a-zA-Z0-9]{6,16}$/
            if (!reg.test(value)) {
                callback(new Error(this.$t('login.AccountFormat')))
            } else {
                callback()
            }
        }
        const validatePass2 = (rule, value, callback) => {
            // const reg = /^(?=.*[a-zA-Z])[a-zA-Z0-9\W_]{8,16}$/g
            const reg = /^(?=\S)(?!.*\s$).{6,}$/
            if (!reg.test(value)) {
                callback(new Error(this.$t('login.PasswordFormat')))
            } else {
                if (this.form1.password !== '') {
                    this.$refs.ruleForm1.validateField('password')
                }
                callback()
            }
        }
        const validatePass3 = (rule, value, callback) => {
            // const reg = /^(?=.*[a-zA-Z])[a-zA-Z0-9\W_]{8,16}$/g
            const reg = /^(?=\S)(?!.*\s$).{6,}$/
            if (!reg.test(value)) {
                callback(new Error(this.$t('login.PasswordFormat')))
            } else {
                if (this.form1.matchPassword !== '') {
                    this.$refs.ruleForm1.validateField('matchPassword')
                }
                callback()
            }
        }
        return {
            domainName,
            act: 1,
            prevAct: 1,
            argeeService: true,
            rememberMe: true,
            debounceTimer: null,
            form1: {
                phone: '',
                password: '',
                matchPassword: '',
                inviteMemberId: ''
            },
            rules1: {
                phone: [
                    { required: true, message: this.$t('login.PleaseEnterYourPhoneNumber'), trigger: 'blur' },
                    { validator: validatePass1, trigger: 'blur' }
                ],
                password: [
                    { required: true, message: this.$t('login.PleaseEnterPassword'), trigger: 'blur' },
                    { validator: validatePass2, trigger: 'blur' }
                ],
                matchPassword: [{ validator: validatePass3, trigger: 'blur' }]
            },
            form2: {
                phone: '',
                password: ''
            },
            rules2: {
                phone: [{ required: true, message: this.$t('login.PleaseEnterAccount'), trigger: 'blur' }],
                password: [{ required: true, message: this.$t('login.PleaseEnterPassword'), trigger: 'blur' }]
            },

            showExitConfirm: false,
            isCanRegister: true,
            timestamp: 0,
            timeData: {},

            phoneCode: ''
        }
    },
    props: {
        isCanClose: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        telegramUserId() {
            return this.$store.getters.telegramUserId
        },
        authTransitionName() {
            return this.act > this.prevAct ? 'auth-drawer-next' : 'auth-drawer-prev'
        },
        eventRegisterReward() {
            return this.$store.state.user.eventRegisterReward
        }
    },
    created() {
        this.open()
    },
    mounted() {
        getNationInfo().then((res) => {
            if (!res) return
            if (res.code) return
            const D = res.result
            D.forEach(x => {
                if (this.BelongNation === x.enumName) {
                    this.phoneCode = '+' + x.code
                }
            })
        })
    },
    methods: {
        close() {
            this.$emit('close')
        },
        onRequestClose() {
            // if (this.act === 1 && this.eventRegisterReward) {
            //     this.showExitConfirm = true
            //     return
            // }
            this.close()
        },
        forceClose() {
            this.showExitConfirm = false
            this.close()
        },
        open() {
            const that = this
            that.act = that.$store.getters.loginType
            if (that.act === 1) that.getDownTimes()
            that.form1.inviteMemberId = that.$store.getters.invitCode || ''
            const rememberInfo = this.$store.getters.rememberInfo
            const form = rememberInfo ? JSON.parse(rememberInfo) : null
            if (form) {
                this.form2.phone = form.phone
                this.form2.password = form.password
            }
            this.onClearValidate()
        },
        onChangeTab(type) {
            this.prevAct = this.act
            this.act = type
            this.onClearValidate()
            this.$store.dispatch('user/changeLoginType', type)
        },
        onClearValidate() {
            this.$nextTick(() => {
                if (this.act === 1) {
                    this.$refs.ruleForm1?.clearValidate()
                }
                if (this.act === 2) {
                    this.$refs.ruleForm2?.clearValidate()
                }
            })
        },
        handleSubmit(formName) {
            const that = this
            clearTimeout(that.debounceTimer)
            that.debounceTimer = setTimeout(() => {
                that.$refs[formName].validate(valid => {
                    if (valid) {
                        if (that.act === 1) {
                            const formData = that.form1
                            if (!that.argeeService) {
                                Toast(that.$t('login.PleaseAgreeOverAge'))
                                return
                            }
                            if (formData.password !== formData.matchPassword) {
                                Toast(that.$t('login.InconsistentPassword'))
                                return
                            }
                            clearTimeout(that.debounceTimer)
                            that.debounceTimer = setTimeout(() => {
                                const userAgent = navigator.userAgent
                                const params = {
                                    ...formData,
                                    // password: md5(formData.password),
                                    // matchPassword: md5(formData.matchPassword),
                                    password: btoa(formData.password),
                                    matchPassword: btoa(formData.matchPassword),
                                    userAgent
                                }
                                const Pixel = that.$store.getters.Pixel
                                if (Pixel) {
                                    params.trafficAcquisitionType = Pixel
                                }
                                const clickId = that.$store.getters.ClickId
                                if (clickId) {
                                    params.clickId = clickId
                                }
                                if (that.$store.getters.TaId) {
                                    params.taid = that.$store.getters.TaId
                                }
                                userRegisterByBash64(params).then(res => {
                                    Toast(res?.message)
                                    if (!res?.code) {
                                        that.$store.dispatch('user/setInvitCode', '')
                                        that.form1.inviteMemberId = ''
                                        that.$store.dispatch('user/changeLoginType', 2)
                                        that.act = 2
                                        that.form2.phone = formData.phone
                                        that.form2.password = formData.password
                                        // login(formData).then(loginRes => {
                                        //     if (loginRes.code === 0) {
                                        //         that.$store.commit('user/SET_TOKEN', `${loginRes.result.tokenHead} ${loginRes.result.token}`)
                                        //         getUserInfo().then((uInfo) => {
                                        //             if (uInfo.code) return
                                        //             that.$store.dispatch('user/saveUserInfo', uInfo.result)
                                        //             that.$websocket.initWebSocket()
                                        //         })
                                        //         that.$store.dispatch('user/setIsShowLoginPopup', false)
                                        //         that.$emit('loginSucc')
                                        //     }
                                        // })
                                    }
                                }).finally(() => {
                                    // uni.hideLoading()
                                })
                            }, 300)
                        } else if (that.act === 2) {
                            that.$store.commit('user/SET_TOKEN', '')
                            const formdata = that.form2
                            const params = {
                                ...formdata,
                                password: md5(formdata.password)
                            }
                            if (that.telegramUserId) {
                                params.telegramUserId = that.telegramUserId
                            }
                            const equipmentId = that.$store.state.system.equipmentId
                            if (equipmentId) params.equipmentId = equipmentId
                            login(params).then(res => {
                                // Toast(res?.message)
                                if (res?.code === 0) {
                                    that.$store.dispatch('user/setInvitCode', '')
                                    that.$store.dispatch('system/setTelegramUserId', '')
                                    if (that.rememberMe) {
                                        that.$store.dispatch('user/setRememberMe', formdata)
                                    } else {
                                        that.$store.dispatch('user/setRememberMe', null)
                                    }
                                    that.$store.commit('user/SET_TOKEN', `${res.result.tokenHead} ${res.result.token}`)
                                    that.$forceUpdate()
                                    getUserInfo().then((uInfo) => {
                                        if (uInfo.code) return
                                        that.$websocket.initWebSocket()
                                    })
                                    that.$store.dispatch('user/setIsShowLoginPopup', false)
                                    that.$emit('loginSucc')
                                }
                            }).finally(() => {
                                // uni.hideLoading()
                            })
                        }
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            }, 300)
        },
        getDownTimes() {
            const that = this
            let sysConfig = that.$store.getters.sysConfig
            if (!sysConfig) {
                const getGonfigInterval = setInterval(() => {
                    sysConfig = that.$store.getters.sysConfig
                    if (sysConfig) {
                        clearInterval(getGonfigInterval)
                        const currentTime = that.getLocalTime()
                        const launchTime = sysConfig.systemLaunchTime ? new Date(sysConfig.systemLaunchTime).getTime() : that.getLocalTime()
                        if (launchTime > currentTime) {
                            that.timestamp = launchTime - currentTime
                            that.isCanRegister = false
                        }
                    }
                }, 300)
            } else {
                const currentTime = that.getLocalTime()
                const launchTime = sysConfig.systemLaunchTime ? new Date(sysConfig.systemLaunchTime).getTime() : that.getLocalTime()
                if (launchTime > currentTime) {
                    that.timestamp = launchTime - currentTime
                    that.isCanRegister = false
                }
            }
        },
        onTimeDownChange(e) {
            this.timeData = e
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.content:after {
    content: "";
    width: 100%;
    height: 3.6rem;
    z-index: -1;
    position: absolute;
    top: 0;
    left: 0;
    background: url(@/assets/common/loginbg.png) no-repeat 50% .2rem / 37% auto;
}

.content {
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    // height: 700px;

    @keyframes move {
        0%, 65% {
            transform: rotate(0);
        }
        70% {
            transform: rotate(6deg);
        }
        75% {
            transform: rotate(-6deg);
        }
        80% {
            transform: rotate(6deg);
        }
        85% {
            transform: rotate(-6deg);
        }
        90% {
            transform: rotate(6deg);
        }
        95% {
            transform: rotate(-6deg);
        }
        100% {
            transform: rotate(0);
        }
    }

    &>.LogReg {
        width: 400px;

        .header {
            position: relative;
            text-align: left;
            padding: .5rem .35rem 2.5rem .35rem;
            font-size: .3rem;

            .moneyVal {
                display: none;
                font-size: .6rem;
                font-weight: 900;
                margin: .05rem 0;
                background-image: linear-gradient(90deg, #ffdd81, #ff9232, #ffdd81);
                background-clip: text;
                -webkit-background-clip: text;
                color: transparent;
            }

            .logo {
                height: auto;
                width: 100%;

                >img {
                    /* 关键1：宽度铺满父级，高度自动按比例缩放 */
                    width: 100%;
                    /* 关键2：高度自动，保证图片比例不变 */
                    height: auto;
                    /* 可选：防止图片被拉伸变形 */
                    object-fit: cover; /* 常用值：cover（铺满容器，裁剪超出）/contain（完整显示，可能留空白） */
                    /* 可选：垂直居中（如果父级有固定高度） */
                    display: block; /* 消除图片默认的行内空白 */
                    margin: 0 auto; /* 水平居中 */
                }
            }

            .close {
                position: absolute;
                top: 16px;
                right: 16px;
                background-color: rgba(0, 0, 0, 0.4);
                border-radius: .1rem;
                padding: .03rem .1rem;
                cursor: pointer;

                .iconfont {
                    font-size: 0.35rem;
                    color: #ffffff;
                    font-weight: 900;
                }
            }
        }

        .LogReg-content {
            padding: 0 .42rem;
        }

        .tabs {
            display: flex;
            align-items: center;
            justify-content: center;
            height: .8rem;
            position: relative;
            padding: 0 .8rem;

            .tab-item {
                color: $font-theme-color;
                box-sizing: border-box;
                font-size: 16px;
                width: 50%;
                height: .68rem;
                line-height: .68rem;
                position: relative;
                cursor: pointer;

                &.act {
                    color: $font-color;
                }

                .empty_img {
                    width: .5rem;
                    height: .5rem;
                    margin-right: .08rem;
                    animation: move 3s linear infinite;
                }
            }

            /* 唯一的一条下划线 */
            .tab-line {
                position: absolute;
                bottom: 0;

                /* 每个 tab 占 50%，下划线宽 30px */
                left: calc(31% - 0.5rem);

                width: 1rem;
                height: 3px;
                border-radius: 3px;
                background-color: $border-active-color;

                /* 移动动画 */
                transition: left 0.3s ease;
            }

            /* 第二个 tab */
            .tab-line.tab-line-right {
                left: calc(69% - 0.5rem);
            }
        }

        .form-box {
            position: relative;

            .time_down_box {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 999;
                background: rgba(15, 5, 53, .5);
                box-sizing: border-box;
                padding-top: 1px;

                .time_down {
                    width: 300px;
                    height: 120px;
                    margin: 0 auto;
                    box-sizing: border-box;
                    background: rgba(0, 0, 0, .7);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    border-radius: 10px;
                    color: #fff;
                    margin-top: 56px;

                    .time_down_title {
                        font-size: 18px;
                        margin-bottom: 12px;
                    }

                    .time_down_time {
                        font-size: 15px;
                        display: flex;
                        align-items: center;

                        .time {
                            color: #ff7300;
                            font-weight: bold;
                            font-size: 16px;
                        }
                    }
                }
            }

            .form {
                padding: .16rem .12rem;
                text-align: left;

                ::v-deep .ant-form {
                    .ant-form-item {
                        margin-bottom: .43rem;

                        &.ant-form-item-with-help {
                            margin-bottom: 2.4px;
                        }

                        .language {
                            width: auto;
                            height: auto;
                            padding-right: .12rem;
                            // border-right: .01rem solid #2a2f39;
                        }
                    }

                    .has-error {
                        .ant-input-prefix {
                            .iconfont {
                                position: relative;

                                &:after {
                                    content: '*';
                                    position: absolute;
                                    color: #EA4E3D;
                                    top: .02rem;
                                    right: -.1.5rem;
                                    font-size: .24rem;
                                }
                            }
                        }

                        .ant-form-explain {
                            height: .44rem;
                            line-height: .2rem;
                            font-size: 0.18rem;
                            padding: .02rem 0;

                            &:not(.show-help-leave)::before {
                                background-color: #EA4E3D;
                                border-radius: 50%;
                                content: "";
                                height: 0.18rem;
                                margin-right: 0.1rem;
                                visibility: visible;
                                width: 0.18rem;
                                display: inline-block;
                                // background-image: url('@/assets/icons.png');
                                background-position: -13.509rem -4.59rem;
                                background-size: 13.689rem 13.419rem;
                            }
                        }
                    }
                }

                .ant-input-affix-wrapper {
                    background-color: transparent;

                    &.phone {
                        ::v-deep input::-webkit-outer-spin-button {
                            -webkit-appearance: none;
                        }

                        ::v-deep input::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                        }

                        ::v-deep input[type='number'] {
                            -moz-appearance: textfield;
                        }

                        ::v-deep .ant-input {
                            padding-left: 1.3rem !important;
                        }
                    }

                    &.account {
                        ::v-deep .language {
                            border-right: .01rem solid #2a2f39;
                        }

                        ::v-deep .ant-input {
                            padding-left: .8rem !important;
                        }
                    }

                    ::v-deep .ant-input-prefix {
                        left: .14rem;
                        color: $font-theme-color;

                        .icon-person,
                        .icon-mima {
                            font-size: .37rem;
                        }

                        .icon-mima {
                            font-size: .34rem;
                        }

                        .icon-open {
                            font-size: .2rem;
                        }

                        .icon-key-fill {
                            font-size: .34rem;
                        }

                        .icon-shebeizhuce {
                            font-size: .34rem;
                        }

                        .flag {
                            width: .28rem;
                            height: 0.22rem;
                            margin-right: .1rem;
                        }

                        span {
                            font-size: .23rem;
                            // margin-right: .1rem;
                            padding-right: .15rem;
                            color: #fff;
                            border-right: .01rem solid #2a2f39;
                        }
                    }

                    ::v-deep .ant-input {
                        // background-color: #000 !important;
                        border-radius: 0.14rem;
                        font-size: 0.26rem;
                        height: 0.85rem;
                        padding: 0px 0.65rem !important;
                        border-radius: 10px;
                        color: #fff;
                        border: 1px solid $border-input-color !important;
                        background: $bg-input-color !important;

                        &:focus {
                            background-color: transparent;
                            border: 1px solid #ff8a00 !important;
                        }

                        &::-webkit-input-placeholder {
                            /* WebKit browsers */
                            font-size: .27rem;
                            color: #9ea2a7;
                            opacity: .9;
                            font-weight: 700 !important;
                        }

                        &:-moz-placeholder {
                            /* Mozilla Firefox 4 to 18 */
                            font-size: .22rem;
                            color: #333;
                        }

                        &::-moz-placeholder {
                            /* Mozilla Firefox 19+ */
                            font-size: .22rem;
                            color: #333;
                        }

                        &:-ms-input-placeholder {
                            /* Internet Explorer 10+ */
                            font-size: .22rem;
                            color: #333;
                        }
                    }

                    ::v-deep .ant-input-suffix {
                        .ant-input-clear-icon {
                            color: #666;
                            font-size: .32rem;
                        }
                    }

                    &.ant-input-password {
                        ::v-deep .ant-input {
                            padding-right: 1rem;
                        }

                        ::v-deep .ant-input-suffix {
                            .ant-input-password-icon {
                                margin-right: .1rem;
                                font-size: .3rem;
                                color: $font-theme-color;
                            }
                        }
                    }
                }

                .remember {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;

                    .check-box {
                        margin-bottom: .01rem;
                        margin-right: .1rem;

                        &>i {
                            font-size: .3rem;
                            color: #ff7300;
                        }

                        &>i.checked {
                            color: #ffffff;
                        }
                    }

                    .txt {
                        color: rgb(255, 138, 0);
                        font-size: .21rem;
                        cursor: pointer;
                    }

                    .tips {
                        color: $font-theme-color;
                        font-size: .22rem;
                        line-height: .38rem;
                        margin-top: 0.03rem;
                    }
                }

                .function {
                    display: flex;
                    justify-content: space-between;

                    span {
                        color: #D1AE52;
                        font-size: .21rem;
                        cursor: pointer;
                    }
                }

                .btn {
                    width: 100%;
                    font-size: .3rem;
                    height: .85rem;
                    text-align: center;
                    line-height: .85rem;
                    border-radius: .5rem;
                    background: $bg-btn-color;
                    color: $font-btn-color;
                    font-weight: 500;
                    margin: .18rem 0;
                    cursor: pointer;

                    &.ant-btn {
                        border-color: transparent;
                    }
                }
            }
        }
    }
}

.loginPopup,
.accountForm {
    .tabs .tab-item {
        color: #d8b97f;
    }

    .ant-input-affix-wrapper {
        &.account ::v-deep .language {
            border-right-color: rgba(205, 137, 61, .24);
        }

        ::v-deep .ant-input-prefix {
            color: #cfa261;

            span {
                border-right-color: rgba(205, 137, 61, .24);
            }
        }

        ::v-deep .ant-input {
            border-color: rgba(205, 137, 61, .36);
            background: rgba(92, 6, 10, .62) !important;

            &:focus {
                border-color: #f3d978 !important;
            }

            &::-webkit-input-placeholder {
                color: #d7b37d;
            }
        }

        &.ant-input-password ::v-deep .ant-input-suffix .ant-input-password-icon {
            color: #cfa261;
        }
    }

    .remember .check-box > i {
        color: #d2a13e;
    }

    .remember .txt,
    .function span {
        color: #f3d978;
    }

    .btn {
        background: linear-gradient(180deg, #fff0b0 0%, #dfb949 54%, #b87c1b 100%);
        color: #5d2e04;
    }
}

.auth-drawer-next-enter-active,
.auth-drawer-next-leave-active,
.auth-drawer-prev-enter-active,
.auth-drawer-prev-leave-active {
    transition: transform .3s ease, opacity .24s ease;
    will-change: transform, opacity;
}

.auth-drawer-next-enter {
    opacity: 0;
    transform: translateX(16%);
}

.auth-drawer-next-leave-to {
    opacity: 0;
    transform: translateX(-16%);
}

.auth-drawer-prev-enter {
    opacity: 0;
    transform: translateX(-16%);
}

.auth-drawer-prev-leave-to {
    opacity: 0;
    transform: translateX(16%);
}

.exit-confirm-mask {
    position: absolute;
    inset: 0;
    background: rgba(6, 15, 33, .64);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 30;
    padding: .24rem;
    box-sizing: border-box;
}

.exit-confirm {
    width: 85%;
    border-radius: .3rem;
    background: $bg-login-color;
    padding: .36rem .34rem .3rem;
    text-align: center;

    &__title {
        font-size: .34rem;
        line-height: 1.35;
        color: #ffffff;
        font-weight: 700;
    }

    &__amount {
        margin-top: .22rem;
        font-size: .62rem;
        line-height: 1;
        color: $font-linght-color;
        font-weight: 800;
        text-shadow: 0 0 .16rem rgba(98, 217, 255, .18);
    }

    &__desc {
        margin-top: .6rem;
        color: $font-theme-color;
        font-size: .26rem;
        line-height: .4rem;
    }

    &__actions {
        margin-top: .64rem;
        display: flex;
        flex-direction: column;
        gap: .18rem;
    }

    &__btn {
        height: .82rem;
        border-radius: .18rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .28rem;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
    }

    &__btn--primary {
        color: $font-btn-color;
        background: $bg-btn-color;
        box-shadow: 0 .12rem .24rem rgba(28, 118, 232, .24);
    }

    &__btn--ghost {
        color: $font-color;
        background: #ffffff0f;
    }
}

.bonus-btn-wrap {
    position: relative;
}

.bonus-badge {
    position: absolute;
    right: .12rem;
    top: -.22rem;
    z-index: 3;
    height: .46rem;
    padding: 0 .14rem 0 .52rem;
    border-radius: .14rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: .2rem;
    font-weight: 700;
    background:
        linear-gradient(180deg, rgba(240, 248, 255, .18) 0%, rgba(240, 248, 255, 0) .08rem),
        linear-gradient(90deg, #ffb239 0%, #ff7e1f 100%);
    box-shadow: 0 .08rem .18rem rgba(255, 129, 32, .24);
    animation: badge-wobble 1.9s ease-in-out infinite;

    &__icon {
        position: absolute;
        left: -.02rem;
        top: 50%;
        width: .58rem;
        height: .58rem;
        transform: translateY(-50%);
        object-fit: contain;
        pointer-events: none;
    }
}

.btn-bonus {
    padding: 0 .32rem !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

@keyframes badge-wobble {
    0%, 100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-.04rem);
    }

    50% {
        transform: translateX(.04rem);
    }

    75% {
        transform: translateX(-.02rem);
    }
}
</style>
